module.exports = __webpack_public_path__ + "img/united-states.f4cc0b5e.svg";